import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  loginStart,
  loginSuccess,
  loginFailure,
} from "../../store/loginReducer";
import { userService } from "../../application/services/userService";
import SvgMapper from "../features/common/SvgMapper";
import { validateEmail } from "../utility/common";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { loading, error } = useSelector((state) => state.login);

  

  const handleLogin = async (e) => {

    if (!email || !password) {
      alert("Please fill all fields");
      return;
    }
    
    if (!validateEmail(email)) {
      alert("Please enter a valid email address");
      return;
    }

    try {
      dispatch(loginStart());
      let role = "admin";
      if (location.pathname === "/student") {
        role = "student";
      } else if (location.pathname === "/admin" || location.pathname === "/") {
        role = "admin";
      }
      
      const response = await userService.authenticate(email, password, role);
      const token = response?.data?.token || null;
      
      
      dispatch(
        loginSuccess({
          email,
          role,
          token: token,
          name: response?.data?.user?.name,
        })
      );

      if (role === "admin") {
        navigate("/admin");
      } else if (role === "student") {
        navigate("/student");
      }
    } catch (err) {
      console.error("Login error:", err);
      dispatch(loginFailure("Invalid credentials. Please try again."));
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="flex items-center justify-center min-h-screen p-4">
        <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-8">
          <div className="flex items-center justify-center mb-2">
            <div className="flex items-center gap-2">
              <div className="bg-yellow-400 p-2 rounded-lg">
                {SvgMapper.interviewIcon("w-6 h-6 text-white")}
              </div>
              <h1 className="text-2xl font-bold text-gray-900">InterviewBot</h1>
            </div>
          </div>
          <p className="text-center text-gray-500 text-sm mb-6">
            Login to start your AI-powered interview
          </p>

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Email
              </label>
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Password
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full px-3 py-2 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                <button
                  type="button"
                  onClick={togglePasswordVisibility}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
                >
                  {showPassword ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                      <line x1="1" x2="23" y1="1" y2="23"></line>
                    </svg>
                  ) : (
                    SvgMapper.eye("w-5 h-5")
                  )}
                </button>
              </div>
            </div>

            {/* Login Button */}
            <button
              type="button"
              onClick={handleLogin}
              disabled={loading}
              className={`w-full py-3 rounded-lg font-medium transition-colors ${
                loading
                  ? "bg-gray-400 cursor-not-allowed text-white"
                  : "bg-yellow-400 hover:bg-yellow-500 text-white"
              }`}
            >
              {loading ? "Logging in..." : "Login"}
            </button>

            {error && (
              <p className="text-red-500 text-center text-sm mt-2">{error}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
